module.exports = __webpack_public_path__ + "img/moralis.59c6b7fa.svg";